import { toFindDuplicates } from '../../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { text } from '../constants'
import type { NewServiceVisitType, SetToastError, VisitTypeErrorState } from '../types'

type CheckNamesDublicatesArgs = {
  serviceTypesList: NewServiceVisitType[]
  errorsConfig: VisitTypeErrorState[]
  setToastError: SetToastError
}

type CheckNamesDublicatesResult = {
  newLocalErrors: VisitTypeErrorState[]
  errorsCount: number
}

export const checkNamesDublicates = ({
  serviceTypesList,
  errorsConfig,
  setToastError,
}: CheckNamesDublicatesArgs): CheckNamesDublicatesResult => {
  let errorsCount = 0

  const localErrors = structuredClone(errorsConfig)
  const names = serviceTypesList.map((t) => (t.Name ?? '').toLowerCase())
  const dublicates: string[] = toFindDuplicates(names).filter(Boolean)

  if (dublicates.length) {
    setToastError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    const serviceTypesWithDublicatesList = serviceTypesList.filter((type) =>
      dublicates.includes((type.Name ?? '').toLowerCase()),
    )

    localErrors.forEach((errorConfig, errorId) => {
      serviceTypesWithDublicatesList.forEach((serviceType) => {
        if (errorConfig.id === serviceType.VisitTypeId) {
          errorsCount += 1
          localErrors[errorId] = {
            ...errorConfig,
            errors: {
              ...errorConfig.errors,
              visitNameLocalError: getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, text.VISIT_NAME),
              visitNameError: true,
            },
          }
        }
      })
    })
  }

  return { newLocalErrors: localErrors, errorsCount }
}
